import { ListChecks, MessageSquare, Calendar } from 'lucide-react';
import { type Page } from '../types/auth';

interface NavigationProps {
  currentPage: Page;
  onPageChange: (page: Page) => void;
}

export function Navigation({ currentPage, onPageChange }: NavigationProps) {
  const navItems = [
    { id: 'tasks', label: 'Tasks', icon: ListChecks },
    { id: 'scrum', label: 'Scrum', icon: MessageSquare },
    { id: 'meetings', label: 'Meetings', icon: Calendar },
  ] as const;

  return (
    <nav className="flex items-center space-x-4">
      {navItems.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onPageChange(id as Page)}
          className={`flex items-center space-x-1 px-3 py-2 rounded-md ${
            currentPage === id
              ? 'bg-gray-100 dark:bg-gray-700'
              : 'hover:bg-gray-50 dark:hover:bg-gray-700'
          }`}
        >
          <Icon className="w-4 h-4" />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}